import { captureException } from "@sentry/browser";

import { config } from "../config";
import {
    ILocationGuessResponse,
    LocationGuessResponse,
} from "../models/location";
import { check } from "../models/utils";
import { PromiseMutex } from "../utils/mutex";

export const guess = async (): Promise<ILocationGuessResponse | null> => {
    const mutex = new PromiseMutex<ILocationGuessResponse | null>(
        "guess-user-location",
    );
    const API_KEY = config.get("IP_API_KEY");
    let loading = mutex.getPromise();
    if (!loading) {
        const params = new URLSearchParams({ key: API_KEY });
        loading = fetch(`https://pro.ip-api.com/json/?${params}`, {
            headers: { Accept: "application/json" },
            credentials: "omit", // External API - don't send cookies
        })
            .then(async (resp): Promise<ILocationGuessResponse | null> => {
                if (!resp.ok) {
                    throw new Error(`HTTP ${resp.status}: ${resp.statusText}`);
                }
                const body = await resp.json();
                if (!body) {
                    return null;
                }
                // Convert numeric lat/lon from API to strings for codec validation
                const coercedBody = { ...body };
                if ("lat" in body && typeof body.lat === "number") {
                    coercedBody.lat = String(body.lat);
                }
                if ("lon" in body && typeof body.lon === "number") {
                    coercedBody.lon = String(body.lon);
                }
                return check(LocationGuessResponse.decode(coercedBody));
            })
            .catch((err) => {
                console.log(err);
                captureException(err);
                return null;
            });
        mutex.setPromise(loading);
    }
    return loading;
};
